<template>
    <!-- address of country-->
    <div class="row g-3 mb-3" :role="ariaLabel != '' ? form : ''" :aria-labelledby="ariaLabel">
        <div class="col-md-12">
            <AppInput
                :name="prefix + 'AddressLine1'"
                :label="$root.t('step3.address1')"
                :rules="address1Required ? 'required' : ''"
            >
                <Input
                    v-model="formData.address1"
                    class-name="form-control"
                    auto-complete="address-line1"
                    :aria-required="address1Required ? true : false"
                />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput :name="prefix + 'AddressLine2'" :label="$root.t('step3.address2')">
                <Input v-model="formData.address2" class-name="form-control" auto-complete="address-line2" />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput :name="prefix + 'AddressLine3'" :label="$root.t('step3.address3')">
                <Input v-model="formData.address3" class-name="form-control" auto-complete="address-line3" />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput :name="prefix + 'State'" :label="$root.t('step3.stateCountry')">
                <Input v-model="formData.state" class-name="form-control" auto-complete="address-level1" />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput :name="prefix + 'City'" :label="$root.t('step3.city')" :rules="cityRequired ? 'required' : ''">
                <Input
                    v-model="formData.city"
                    class-name="form-control"
                    auto-complete="address-level2"
                    :aria-required="cityRequired ? true : false"
                />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput
                :name="prefix + 'ZipOrPostalCode'"
                :label="$root.t('step3.zipCode')"
                :rules="zipCodeRequired ? 'required' : ''"
            >
                <Input
                    v-model="formData.zipCode"
                    class-name="form-control"
                    auto-complete="postal-code"
                    :aria-required="zipCodeRequired ? true : false"
                />
            </AppInput>
        </div>

        <div class="col-md-6">
            <AppInput
                :name="prefix + 'Country'"
                :label="$root.t('step3.country')"
                :rules="countryRequired ? 'required' : ''"
            >
                <AppSelect
                    v-model="formData.countryId"
                    :readonly="countryReadonly"
                    :options="optionCountries"
                    :placeholder="$t('common.defaultSelectionValue')"
                    searchable
                />
            </AppInput>
        </div>
    </div>
</template>

<script>
import AppSelect from '../../shared/AppSelect.vue'
import Input from '../../shared/Input.vue'
export default {
    name: 'AddressForm',
    components: {
        AppSelect,
        // eslint-disable-next-line vue/no-reserved-component-names
        Input,
    },
    props: {
        formData: {
            type: Object,
            required: true,
        },
        optionCountries: {
            type: Array,
            required: true,
        },
        prefix: {
            type: String,
            default: '',
        },
        isPartial: {
            type: Boolean,
            default: false,
        },
        address1Required: {
            type: Boolean,
            default: false,
        },
        cityRequired: {
            type: Boolean,
            default: false,
        },
        zipCodeRequired: {
            type: Boolean,
            default: false,
        },
        countryRequired: {
            type: Boolean,
            default: true,
        },
        countryReadonly: {
            type: Boolean,
            default: false,
        },
        ariaLabel: {
            type: String,
            default: '',
        },
    },
    data() {
        return {}
    },
}
</script>
